export enum EmailMarketingProviderType {
    None = "None",
    Maileroo = "Maileroo",
    Mailchimp = "Mailchimp",
    CampaignMonitor = "CampaignMonitor"
  }
// Index position matches the C# EmailMarketingProviderType enum's integer values
// (None=0, Maileroo=1, Mailchimp=2, CampaignMonitor=3), which is how providerType
// arrives over the wire. Indexing this list resolves that integer to the typed enum.
// Keep this order in sync with investi.Core/Email/EmailMarketingProviderType.cs.
export const EmailMarketingProviderList = [
  EmailMarketingProviderType.None,
  EmailMarketingProviderType.Maileroo,
  EmailMarketingProviderType.Mailchimp,
  EmailMarketingProviderType.CampaignMonitor
];